var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Radio',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPopup),expression:"!showPopup"}]}),_c('div',{staticClass:"particles",attrs:{"id":"particles-slow"}}),_c('div',{staticClass:"brightness"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }